import { useTranslations } from '@vocab/react';
import { Stack, Box, Text, ContentBlock } from 'braid-design-system';

import { useGroup } from 'src/provider/group';
import { usePage } from 'src/provider/page';

import translations from './.vocab';

export default () => {
  const { t } = useTranslations(translations);
  const { pageDispatch } = usePage();
  const { groupState } = useGroup();
  const { category } = groupState;

  return (
    <Box
      display={{ mobile: 'none', tablet: 'none', desktop: 'flex' }}
      justifyContent="spaceBetween"
      paddingY="xxlarge"
      paddingX="gutter"
      style={{ background: '#F3F5F7' }}
    >
      <ContentBlock width="large">
        <Stack space="medium">
          <Text weight="strong">{t('explore-groups')}</Text>
          <Box style={{ columnCount: 4 }}>
            {category.map((item, idx) => (
              <Box key={idx} background="neutralLight" marginBottom="medium">
                <a
                  key={item.groupId}
                  href={item.url}
                  style={{ textDecoration: 'none' }}
                  onClick={() => {
                    pageDispatch({ type: 'IS_LOADING' });
                  }}
                >
                  <Text tone="formAccent" size="small">
                    {' '}
                    {item.name}
                  </Text>
                </a>
              </Box>
            ))}
          </Box>
        </Stack>
      </ContentBlock>
    </Box>
  );
};
